module.exports = __webpack_public_path__ + "static/media/M mall shot 05.b0e38bc7.webp";